import { Controller } from '@hotwired/stimulus';

export default class AccordionItemController extends Controller {
  static targets = ['valueDisplay'];
  static values = { emptyState: String };

  connect() {
    if (!this.valueDisplayTarget.innerText.trim()) {
      this.valueDisplayTarget.innerText = this.emptyStateValue;
    }
  }

  onChange(event) {
    this.valueDisplayTarget.innerText = event.detail.displayValue || this.emptyStateValue;
  }
}
